
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { useTranslation } from "react-i18next";
import { trackTripCardAction } from "@/utils/analytics";

export const useCurrencyData = (tripId: string, destinationName: string) => {
  const [showCurrency, setShowCurrency] = useState(false);
  const [currencyData, setCurrencyData] = useState<any>(null);
  const { toast } = useToast();
  const { t } = useTranslation();

  const handleCurrencyClick = async () => {
    try {
      setShowCurrency(true);
      trackTripCardAction("currency", tripId, destinationName);
      
      // Mock data for now
      setCurrencyData({
        sourceCurrency: "USD",
        targetCurrency: "EUR",
        exchangeRate: 0.92,
        lastUpdated: new Date().toISOString()
      });
    } catch (error) {
      console.error('Error handling currency:', error);
      toast({
        variant: "destructive",
        description: "An error occurred while fetching currency data"
      });
    }
  };

  return {
    showCurrency,
    setShowCurrency,
    currencyData,
    handleCurrencyClick
  };
};
